import TawkChat from "./tawkChatProxy";

/**
 * Registra los handlers de eventos a los elementos html para poder operar.
 */
function bindEvents() {
  /* Los eventos se registran siempre, exista o no chat. Las operaciones se
   * implementan para tenerlo en cuenta. */
  $("#ims-tawkchat-button")
    .off("click")
    .click(() => {
      TawkChat.popup();
      update();
    });
}

/**
 * Actualiza el componente del estado del chat cada vez que se produce un cambio
 * de estado.
 */
function update() {
  const controllerElement = $("#ims-tawkchat-controller");
  const status = TawkChat.getStatus();

  if ((status === "online" || status === "away") && !TawkChat.isChatMaximized()) {
    /* Hay estado y el chat no está abierto. Se debe mostar el controlador. */
    const statusTextElement = $("#ims-tawkchat-status-text");
    const statusText = statusTextElement.attr(`data-ims-${status}-msg`);

    if (statusText != null) {
      statusTextElement.html(statusText);
    }

    controllerElement.show();
  } else {
    /* Si no hay componente, o está offline o ya está abierto, nos ocultamos. */
    controllerElement.hide();
  }
}

/**
 * Inicializa el compomente
 */
export default function initialize(): void {
  /* El chat puede estar inicializado o no. Si ya lo está, el evento "onLoad" lo
   * hemos perdido. Si no lo está, hay que esperar al mismo. */

  /* Primero registramos el handler para no perder el evento si se produce
   * mientras inicializamos. */
  TawkChat.setOnLoadHandler(update);

  /* Registramos también en el evento de ocultarse y al cambiar el estado. */
  TawkChat.setOnChatHiddenHandler(update);
  TawkChat.setOnStatusChangeHandler(update);

  /* Registramos los eventos al controlador del chat. */
  bindEvents();

  /* Por si llegamos tarde y ya se ha incializado, forzmos un update. */
  update();
}
